import React from "react";

export const PLTopBackground = () =>
<div className="top-background">
    <svg viewBox="0 0 1440 297" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H1440V154.198C893.774 343.349 578.589 344.506 0 154.198V0Z"/>
    </svg>
</div>
